import React, { useEffect, useRef, useState } from "react";
import {
  Container,
  DivIconRounded,
  Header,
  ContainerLeftModal,
  ContainerRightModal,
  LeftHeaderWhiter,
  ButtonEdit,
  RefreshButton
} from "./styles";
import {
  Back,
  IconFile,
  LightIcon,
  spaikIcon,
  TemplatePageIcon
} from "../../assets";
import * as comunCss from "../comum_css";
import { Button, DataTable, Dropdown, InputText } from "../";
import { Column } from "primereact/column";
import { css } from "@emotion/react";
import { DropdownChangeParams } from "primereact/dropdown";
import { useAppSelector, useAppDispatch } from "../../redux/hooks";
import DialogPadrao from "../DialogPadrao";
import { setShowModalCreateTemplate } from "../../redux/slices/templates";
import { AuthContextType, useAuth } from "../../auth/auth-provider";
import { Text } from "../Text/text";
import CreateWhatsAppTemplate from "../UpdateWhatsAppTemplate";
import useWhatsAppTemplatesApi, {
  TemplateDto,
  ComponentDto,
  ButtonDto,
  HeaderFormat
} from "../WhatsAppTemplates/use-whatsAppTemplates";
import { Menu } from "primereact/menu";
import { useToast } from "../toast-provider";
import { Dialog } from "primereact/dialog";
import { IoIosPlay } from "react-icons/io";
import { useNavigate } from "react-router-dom";
import { Tooltip } from "primereact/tooltip";

const WhatsAppTemplatesList = () => {
  const dispatch = useAppDispatch();
  const { user } = useAuth() as AuthContextType;
  const menu = useRef<Menu>(null);
  const toast = useToast();
  const [tablePropsData, setTablePropsData] = useState({});
  const [templates, setTemplates] = useState<TemplateDto[]>([]);
  const [rowSelected, setRowSelected] = useState<TemplateDto | null>(null);
  const [templateToEdit, setTemplateToEdit] = useState<any | null>(null);
  const [formMode, setFormMode] = useState<"create" | "edit">("create");
  const [showModalDelete, setShowModalDelete] = useState(false);
  const navigate = useNavigate();
  const { getTemplates, deleteTemplate } = useWhatsAppTemplatesApi();
  const showModalCreateTemplate = useAppSelector(
    (state) => state.templates.showModalCreateTemplate
  );
  const botIdActive = useAppSelector(
    (state) => state.flowInteractions.botIdActive
  );
  const BOT_ID_KEY = "botIdActive";
  const effectiveBotId =
    botIdActive > 0
      ? botIdActive
      : Number(localStorage.getItem(BOT_ID_KEY) || 0);

  const openCreate = () => {
    setFormMode("create");
    setTemplateToEdit(null);
    dispatch(setShowModalCreateTemplate(true));
  };

  const openEdit = (template: TemplateDto) => {
    setFormMode("edit");
    setTemplateToEdit(template);
    dispatch(setShowModalCreateTemplate(true));
  };

  const paginatorCustomTemplate = {
    layout: "RowsPerPageDropdown PrevPageLink PageLinks NextPageLink",
    RowsPerPageDropdown: (options: {
      value: number;
      onChange: ((e: DropdownChangeParams) => void) | undefined;
    }) => {
      const dropdownOptions = [
        { label: 20, value: 20 },
        { label: 50, value: 50 },
        { label: 100, value: 100 }
      ];

      return (
        <div
          style={{
            display: "flex",
            alignItems: "center"
          }}
        >
          <span
            style={{
              minWidth: "fit-content",
              color: "#2624CD"
            }}
          >
            Por página:
          </span>

          <Dropdown
            value={options.value}
            options={dropdownOptions}
            onChange={options.onChange}
            appendTo="self"
            css={css`
              .p-inputtext {
                color: #6e6b7b;
              }
              .p-dropdown-panel .p-dropdown-items .p-dropdown-item.p-highlight {
                background: #2624cd;
              }
            `}
          />
        </div>
      );
    }
  };

  const inputStyles = css`
    width: 342px;

    @media screen and (max-width: 505px) {
      width: 100%;
    }
  `;

  useEffect(() => {
    if (effectiveBotId < 1) {
      toast?.current?.show({
        life: 5000,
        severity: "warn",
        summary: "Atenção",
        detail: "Nenhum bot selecionado."
      });
      return;
    }

    getAllTemplates(effectiveBotId);
  }, [effectiveBotId]);

  const getAllTemplates = async (botId: number) => {
    try {
      const results = await getTemplates(botId);
      setTemplates(results.data);
    } catch (error: any) {
      const backendMessage =
        error?.message ||
        error?.response?.data?.message ||
        "Erro ao listar os templates.";

      toast?.current?.show({
        life: 5000,
        severity: "error",
        summary: "Erro",
        detail: backendMessage
      });
    } finally {
      localStorage.setItem(BOT_ID_KEY, String(botId));
    }
  };

  const handleDeleteSelectedTemplate = async () => {
    if (!rowSelected) return;

    try {
      await deleteTemplate(effectiveBotId, rowSelected.id, rowSelected.name);
      await getAllTemplates(effectiveBotId);

      setRowSelected(null);
    } catch (error: any) {
      const backendMessage =
        error?.message ||
        error?.response?.data?.message ||
        "Erro ao excluir template.";

      toast?.current?.show({
        life: 5000,
        severity: "error",
        summary: "Erro",
        detail: backendMessage
      });
    } finally {
      setShowModalDelete(false);
    }
  };

  const categoryLabel = (category?: string) => {
    if (category === "MARKETING") return "Marketing";
    if (category === "UTILITY") return "Utilidade";
    return category ?? "";
  };

  const languageLabel = (language?: string) => {
    if (language === "pt_BR") return "Português";
    if (language === "en_US") return "Inglês";
    if (language === "es_ES") return "Espanhol";
    return language ?? "";
  };

  const actionBodyTemplate = (rowData: TemplateDto) => {
    return (
      <div style={{ display: "flex", justifyContent: "center" }}>
        <ButtonEdit
          onClick={(event) => {
            setRowSelected(rowData);
            menu.current?.toggle(event);
          }}
          aria-controls="popup_template_actions"
          aria-haspopup
        >
          Editar
        </ButtonEdit>
      </div>
    );
  };

  const menuItems = [
    {
      label: "Editar",
      command: () => {
        if (rowSelected) openEdit(rowSelected);
      }
    },
    {
      label: "Excluir",
      command: () => setShowModalDelete(true)
    }
  ];

  return (
    <Container>
      <div className="p-5 gap-2">
        <Header>
          <div className="header" css={comunCss.TitleContent}>
            <DivIconRounded>
              <img src={TemplatePageIcon} style={{ width: "20px" }} />
            </DivIconRounded>
            Modelos de mensagem
          </div>

          <RefreshButton>
            <Button
              className="mr-1 room-managment-button tooltip-for-first-button"
              onClick={() => {
                getAllTemplates(effectiveBotId);
              }}
            >
              <i className="pi pi-refresh room-icon" />
            </Button>
            <Tooltip target=".tooltip-for-first-button" position="bottom">
              Atualizar
            </Tooltip>
          </RefreshButton>
        </Header>

        <Menu model={menuItems} popup ref={menu} id="popup_template_actions" />

        <DataTable
          {...tablePropsData}
          filterDelay={600}
          emptyMessage="Nenhum resultado encontrado"
          paginatorTemplate={paginatorCustomTemplate}
          value={templates}
          dataKey="id"
        >
          <Column field="name" header="Nome" headerStyle={{ width: "40%" }} />

          <Column
            field="category"
            header="Categoria"
            headerStyle={{ width: "15%" }}
            align="center"
            alignHeader="center"
            body={(rowData) => categoryLabel(rowData.category)}
          />
          <Column
            field="language"
            header="Idioma"
            headerStyle={{ width: "15%" }}
            body={(rowData) => languageLabel(rowData.language)}
          />

          <Column
            field="status"
            header="Status"
            align="center"
            alignHeader="center"
            headerStyle={{ width: "15%" }}
            body={(rowData) => {
              const status = rowData.status;

              const bg =
                status === "APPROVED"
                  ? "#AEE9D1"
                  : status === "REJECTED"
                  ? "#F44336"
                  : status === "PENDING"
                  ? "#FFA940"
                  : "#C1C1C1";

              const label =
                status === "APPROVED"
                  ? "Aprovado"
                  : status === "REJECTED"
                  ? "Reprovado"
                  : status === "PENDING"
                  ? "Pendente"
                  : status;

              return (
                <div className="statusDiv">
                  <div className="status" style={{ background: `${bg}` }}>
                    {label}
                  </div>
                </div>
              );
            }}
          />

          <Column
            header="Ação"
            headerStyle={{ width: "10%" }}
            align="center"
            body={actionBodyTemplate}
          />
        </DataTable>
      </div>

      <DialogPadrao
        displayDialog={showModalCreateTemplate}
        contentStyle={{ height: "700px" }}
        onHide={() => {
          dispatch(setShowModalCreateTemplate(false));
          setFormMode("create");
          setTemplateToEdit(null);
          setRowSelected(null);
        }}
        headerStyle={{
          backgroundColor: user.plataform.mainColor || "#2624CD"
        }}
      >
        <LeftHeaderWhiter />
        <ContainerLeftModal>
          <CreateWhatsAppTemplate
            mode={formMode}
            template={templateToEdit}
            onSuccess={async () => {
              await getAllTemplates(effectiveBotId);
            }}
          />
        </ContainerLeftModal>
        <ContainerRightModal>
          <div className="flex align-items-center justify-content-center">
            {user.plataform.urlAvatar ? (
              <img
                src={user.plataform.urlAvatar}
                alt="imgBot"
                style={{ height: "120px" }}
              />
            ) : (
              <img src={spaikIcon} style={{ height: "120px" }} alt="imgBot" />
            )}
          </div>
          <div className="titleTips">Dicas para criar modelos</div>
          <div className="textTips">
            Use variáveis como {"{{1}}"} e {"{{2}}"} para personalizar suas
            mensagens. A Meta analisa o conteúdo para garantir a segurança e
            integridade dos serviços.
          </div>

          <div className="topics">
            <div className="topic">
              <div className="divImage">
                <img
                  src={LightIcon}
                  style={{ height: "18px", color: "#fff" }}
                />
              </div>
              <div className="textTopic">
                <div>Seja claro e objetivo</div>
                <div className="textTip">
                  Mensagens curtas têm melhor engajamento
                </div>
              </div>
            </div>

            <div className="topic">
              <div className="divImage">
                <i className="pi pi-comment" />
              </div>
              <div className="textTopic">
                <div>Use variáveis</div>
                <div className="textTip">
                  Personalize com {"{{1}}"}, {"{{2}}"}, etc.
                </div>
              </div>
            </div>

            <div className="topic">
              <div className="divImage">
                <img
                  src={IconFile}
                  style={{
                    height: "18px",
                    filter: "brightness(0) invert(1)"
                  }}
                />
              </div>
              <div className="textTopic">
                <div>Categorize corretamente</div>
                <div className="textTip">
                  Escolha entre Marketing, Utilitário ou Autenticação
                </div>
              </div>
            </div>

            <div className="topic" style={{ cursor: "pointer" }}>
              <div className="divVideo">
                <IoIosPlay size={20} color="white" />
              </div>
              <div className="textTopic">
                <div>Vídeo - Como criar modelos</div>
              </div>
            </div>
          </div>
        </ContainerRightModal>
      </DialogPadrao>

      <Dialog
        visible={showModalDelete}
        onHide={() => setShowModalDelete(false)}
        draggable={false}
        header="Deseja excluir o template?"
        style={{ width: "575px" }}
      >
        <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
          <div>
            Ao continuar, o template será excluído e essa ação não poderá ser
            desfeita.
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "end",
              gap: "15px"
            }}
          >
            <Button
              label="Sim"
              className="p-button-danger"
              onClick={() => {
                handleDeleteSelectedTemplate();
              }}
            />
            <Button
              label="Não"
              className="p-button-secondary"
              onClick={() => setShowModalDelete(false)}
            />
          </div>
        </div>
      </Dialog>
    </Container>
  );
};

export default WhatsAppTemplatesList;
